document.addEventListener("DOMContentLoaded", (event) => {
    let popUp = document.querySelector('.popup_royal_service');
    let bg_overlay = document.querySelector('.popup_royal_service_overlay');
    let btnClosePopupRoyal = document.querySelector('.btn_close_popup_royal');

    function hiddenPopup() {
        sessionStorage.setItem('newsletter', true);
        popUp.classList.add('hidden');
        document.body.classList.remove('open_popup');
        bg_overlay?.classList.add('hidden');
    }

    if (popUp) {
        popUp.classList.remove('hidden');
        document.body.classList.add('open_popup');
        bg_overlay?.classList.remove('hidden');

        if (sessionStorage.getItem('newsletter')) {
            popUp.classList.add('hidden');
            document.body.classList.remove('open_popup');
            bg_overlay?.classList.add('hidden');
        } else {
            popUp.classList.remove('hidden');
            document.body.classList.add('open_popup');
            bg_overlay?.classList.remove('hidden');
        }
    }

    if (bg_overlay) {
        bg_overlay.addEventListener('click', function() {
            hiddenPopup();
        });
    }

    if (btnClosePopupRoyal) {
        btnClosePopupRoyal.addEventListener('click', function() {
            hiddenPopup();
        });
    }

    
    setTimeout(() => {
        let elmBoxFormCrewRegister = document.querySelector('.box_tag_crew_register');
         let btn
      if(elmBoxFormCrewRegister ){
          btn = elmBoxFormCrewRegister.querySelector('button.needsclick.go3894874857');
      }
       
        var letGet = false;
        if(elmBoxFormCrewRegister) {
          
            let elmInputsText = elmBoxFormCrewRegister.querySelectorAll('input[type="text"], input[type="email"], input[type="tel"], textarea, select')
            let elmInputsCheckbox = elmBoxFormCrewRegister.querySelectorAll('input[type="checkbox"]');
            let blogCustomContent = elmBoxFormCrewRegister.querySelector('.blog_custom_content');

            function handleClick() {
                letGet = true;
                if (blogCustomContent) {
                    blogCustomContent.classList.add('active')
                    let newDiv = document.createElement('div');
                    newDiv.classList.add('heading-custom');
                    newDiv.innerHTML = '<h2>Here is your information</h2>';
                    let firstChild = blogCustomContent.firstElementChild;
                    blogCustomContent.insertBefore(newDiv, firstChild);
                }
                    let val = [];
                    elmInputsCheckbox.forEach(input => {
                        if(input.checked) {
                            val.push(input.getAttribute('aria-label'));
                        } else {
                            val = val.filter(item => item !== input.getAttribute('aria-label'));
                        }
                    });

                    if (val.length > 0) {
                        elmBoxFormCrewRegister.querySelector(`[data-ref="ref-availability"]`).textContent = val.join(' | ');
                        localStorage.setItem('ref-availability', val.join(' | '));
                    } else {
                        elmBoxFormCrewRegister.querySelector(`[data-ref="ref-availability"]`).textContent = '';
                    }
                    
                elmInputsText.forEach((input) => {
                    let attrId = input.getAttribute('id');
                    if (attrId.includes('Crew_full_name') && letGet) {
                        elmBoxFormCrewRegister.querySelector(`[data-ref="ref-fullname"]`).textContent = input.value;
                        localStorage.setItem('ref-fullname', input.value);
                    }
                    // Tiếp tục với các xử lý khác tại đây nếu cần
                    if(attrId.includes('phone_number') && letGet) {
                            elmBoxFormCrewRegister.querySelector(`[data-ref="ref-tel"]`).textContent = input.value
                            localStorage.setItem('ref-tel',  input.value);
                      
                    }
                    if(attrId.includes('Crewing_experience') && letGet) {
                        elmBoxFormCrewRegister.querySelector(`[data-ref="ref-crewing-experience"]`).textContent = input.value
                        localStorage.setItem('ref-crewing-experience',  input.value);
                  
                    }
                    if(attrId.includes('email') && letGet) {
                        elmBoxFormCrewRegister.querySelector(`[data-ref="ref-email"]`).textContent = input.value
                        localStorage.setItem('ref-email',  input.value);
                  
                    }

                });
                
            }
          if(btn){
              btn.addEventListener('click', handleClick);
          }
          
        }
    }, 3500);

        let fullnameElement = document.querySelector('.box_tag_crew_register h3[data-ref="ref-fullname"]');
        let telElement = document.querySelector('.box_tag_crew_register span[data-ref="ref-tel"]');
        let experienceElement = document.querySelector('.box_tag_crew_register div[data-ref="ref-crewing-experience"]');
        let emailElement = document.querySelector('.box_tag_crew_register span[data-ref="ref-email"]');
        let abilityElement = document.querySelector('.box_tag_crew_register span[data-ref="ref-availability"]');
    
        let name = localStorage.getItem('ref-fullname');
        let tel = localStorage.getItem('ref-tel');
        let experience = localStorage.getItem('ref-crewing-experience');
        let email = localStorage.getItem('ref-email');
        let ability = localStorage.getItem('ref-availability');

        if(fullnameElement && name){
            let blogCustomContent = document.querySelector('.blog_custom_content');
            blogCustomContent.classList.add('active')
            let newDiv = document.createElement('div');
            newDiv.classList.add('heading-custom');
            newDiv.innerHTML = '<h2>Here is your information</h2>';
            let firstChild = blogCustomContent.firstElementChild;
            blogCustomContent.insertBefore(newDiv, firstChild);
            fullnameElement.textContent = name;
        }
        if(telElement && tel){
            telElement.textContent = tel;
        }
        if(experienceElement && experience){
            experienceElement.textContent = experience;
        }
        if(emailElement && email){
            emailElement.textContent = email;
        }
        if(abilityElement && ability){
            abilityElement.textContent = ability;
        }
   
});
